import axios from 'axios';

const state = {
    nodeServers: [],
    nodeServer: null,
};

const getters = {
    getNodeServers: state => state.nodeServers,
    getNodeServer: state => state.nodeServer,
};

const actions = {
    // Get list of node servers with pagination and filters
    admin_node_servers_list({ commit }, data) {
        return new Promise((resolve, reject) => { 
            axios.get('admin/node-servers', { params: data })
            .then(response => {
                commit("SET_NODE_SERVERS", response.data.data.node_servers || [])
                resolve(response)
            })
            .catch(err => {
                reject(err)
            })
        })
    },

    // Get node servers for dropdown
    admin_node_servers_dropdown({ commit }) {
        return new Promise((resolve, reject) => { 
            axios.get('admin/node-servers/dropdown')
            .then(response => {
                commit("SET_NODE_SERVERS", response.data.data.node_servers || [])
                resolve(response)
            })
            .catch(err => {
                reject(err)
            })
        })
    },

    // Get single node server by ID
    admin_node_server_detail({ commit }, data) {
        return new Promise((resolve, reject) => { 
            axios.get('admin/node-server/' + data.id)
            .then(response => {
                commit("SET_NODE_SERVER", response.data.data.node_server)
                resolve(response)
            })
            .catch(err => {
                reject(err)
            })
        })
    },

    // Create new node server
    admin_node_server_create({ commit }, data) {
        return new Promise((resolve, reject) => { 
            axios.post('admin/node-server', data)
            .then(response => {
                commit("PUSH_NODE_SERVER", response.data.data.node_server)
                resolve(response)
            })
            .catch(err => {
                reject(err)
            })
        })
    },

    // Update node server
    admin_node_server_update({ commit }, data) {
        return new Promise((resolve, reject) => { 
            axios.put('admin/node-server/' + data?.id, data)
            .then(response => {
                commit("UPDATE_NODE_SERVER", response.data.data.node_server)
                resolve(response)
            })
            .catch(err => {
                reject(err)
            })
        })
    },

    // Delete node server
    admin_node_server_delete({ commit }, id) {
        return new Promise((resolve, reject) => { 
            axios.delete('admin/node-server/' + id)
            .then(response => {
                commit("REMOVE_NODE_SERVER", id)
                resolve(response)
            })
            .catch(err => {
                reject(err)
            })
        })
    },

    // Get all node servers with monitoring status (admin only)
    admin_node_servers_status() {
        return new Promise((resolve, reject) => { 
            axios.get('admin/node-servers/status')
            .then(response => {
                resolve(response)
            })
            .catch(err => {
                reject(err)
            })
        })
    },

};

const mutations = {
    SET_NODE_SERVERS(state, nodeServers) {
        state.nodeServers = nodeServers;
    },
    SET_NODE_SERVER(state, nodeServer) {
        state.nodeServer = nodeServer;
    },
    PUSH_NODE_SERVER(state, nodeServer) {
        state.nodeServers.push(nodeServer);
    },
    UPDATE_NODE_SERVER() {
        // const index = state.nodeServers.findIndex(server => server.id === updatedNodeServer.id);
        // if (index !== -1) {
        //     state.nodeServers.splice(index, 1, updatedNodeServer);
        // }
    },
    REMOVE_NODE_SERVER(state, id) {
        state.nodeServers = state.nodeServers.filter(server => server.id !== id);
    },
};

export default {
    state,
    getters,
    actions,
    mutations
};
